module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1207.a470db8f.png";